import { forwardRef } from 'react';

export const UiNativeSelect = forwardRef(function UiNativeSelect(
  { label, error, className = '', style, selectClassName = '', children, ...selectProps },
  ref,
) {
  return (
    <label className={`ui-field ${className}`.trim()} style={style}>
      {label ? <span className="ui-field__label">{label}</span> : null}
      <select {...selectProps} ref={ref} className={`ui-control ui-control--select ${selectClassName}`.trim()}>
        {children}
      </select>
      {error ? <span className="form-error">{error}</span> : null}
    </label>
  );
});
